module.exports = __webpack_public_path__ + "media/app/assets/imgs/exchange/follow-ea70be5811b0d9f6b28a9af85e317692.png";